// extracted by mini-css-extract-plugin
module.exports = {"switchBtn":"Inputs_switchBtn__cpmCQ"};